export default class Validator {
  constructor(inputs, selectors) {
    this.vars(inputs, selectors);
  }

  vars(inputs, selectors) {
    this.selectors = selectors;
    this.inputs = inputs;
    this.hasErrors = false;

    return true;
  }

  shouldValidate(search) {
    const validables = ["name", "mail", "message", "rule-01"];
    return validables.indexOf(search) >= 0;
  }

  validate() {
    this.hasErrors = false;
    this.inputs.forEach(input => {
      input.errors = [];
      this.handleErrors(input, true);
      if (this.shouldValidate(input.name)) {
        if (input.name !== "select" && !input.field.value.length) {
          input.errors.push("required");
        }
        if (input.name === "mail" && !this.validateEmail(input.field.value)) {
          input.errors.push("mail");
        }
        if (input.name === "rule-01" && !input.field.checked) {
          input.errors.push("rule");
        }
        if (input.errors.length) this.hasErrors = true;
        this.handleErrors(input);
      }
    });
    return this.hasErrors ? false : true;
  }

  handleErrors(input, hide = false) {
    if (!input.errors.length && !hide) return false;
    if (input.name === "rule-01") {
      this.handleRule(input, hide);
    } else if (input.name !== "rule-02") {
      this.handleErrorText(input, hide);
    }
  }

  handleRule(input, hide) {
    const checkboxWrapper = input.field.closest(
      `.${this.selectors.checkboxWrapper}`
    );
    if (!hide) {
      checkboxWrapper.classList.add(this.selectors.error);
    } else {
      checkboxWrapper.classList.remove(this.selectors.error);
    }
  }

  handleErrorText(input, hide) {
    if (input.name === "select" && !input.field) {
      input.field = this.selectricEl;
    }

    const errorText = input.field
      .closest(`.${this.selectors.inputWrapper}`)
      .querySelector(`.${this.selectors.errorText}`);
    if (!hide) {
      input.field.classList.add(this.selectors.error);
      errorText.classList.add(this.selectors.visible);
    } else {
      input.field.classList.remove(this.selectors.error);
      errorText.classList.remove(this.selectors.visible);
    }
  }

  validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
}
